var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.444,
    height: 24,
    viewBox: "0 0 31.444 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #38c20a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-check-for-payment",
    className: "cls-1",
    d: "M3.859,3A2.788,2.788,0,0,0,1,5.667V8.333A2.788,2.788,0,0,0,3.859,11H6.717V27H9.576a1.433,1.433,0,0,1,2.859,0h2.859a1.433,1.433,0,0,1,2.859,0H21.01a1.433,1.433,0,0,1,2.859,0h2.859V11h2.859a2.788,2.788,0,0,0,2.859-2.667V5.667A2.788,2.788,0,0,0,29.585,3Zm0,2.667H6.717V8.333H3.859Zm5.717,0H23.868V23H9.576Zm17.151,0h2.859V8.333H26.727ZM12.434,8.333V11H21.01V8.333Zm0,5.333v2.667h5.717V13.667Z",
    transform: "translate(-1 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.7bc5907ff749eda1b1dee5d079386df6.svg";
export { ForwardRef as ReactComponent };